"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-fd284050"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "searchbar-input-container" };
const _hoisted_2 = { class: "searchbar-input-wrapper" };
const _hoisted_3 = ["placeholder"];
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "zmdi zmdi-search zmdi-hc-lg searchbar-icon" }, null, -1 /* HOISTED */));
const _hoisted_5 = [
    _hoisted_4
];
const vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'SearchBar',
    props: {
        paramInput: {
            type: String,
            default: ""
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        isSearchBarOpen: {
            type: Boolean,
            default: false,
        },
        placeholderText: {
            type: String,
            default: "名前、タグ",
        },
        searchOnInput: {
            type: Boolean,
            default: false, // default to submit-based search
        },
    },
    emits: ["emit-search-on-submit", "emit-open-search-bar", "emit-search-on-input"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const inputText = (0, vue_3.ref)("");
        function handleSearchClick() {
            if (!props.isSearchBarOpen) {
                emit("emit-open-search-bar");
                return;
            }
            if (props.isLoading) {
                return;
            }
            emit("emit-search-on-submit", inputText.value);
        }
        function handleInputChange() {
            if (!props.searchOnInput || !props.isSearchBarOpen || props.isLoading) {
                return;
            }
            emit("emit-search-on-input", inputText.value);
        }
        const isLoadingClass = (0, vue_3.computed)(() => {
            return props.isLoading ? 'loading' : '';
        });
        const searchBarClass = (0, vue_3.computed)(() => {
            return props.isSearchBarOpen ? 'open' : 'closed';
        });
        (0, vue_3.onMounted)(() => {
            inputText.value = props.paramInput;
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("form", {
                    class: "d-flex",
                    onSubmit: (0, vue_2.withModifiers)(handleSearchClick, ["prevent"])
                }, [
                    (0, vue_2.createElementVNode)("div", _hoisted_2, [
                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((inputText).value = $event)),
                            class: (0, vue_2.normalizeClass)(["form-input searchbar-input", searchBarClass.value]),
                            type: "text",
                            placeholder: __props.placeholderText,
                            onInput: handleInputChange
                        }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_3), [
                            [vue_2.vModelText, inputText.value]
                        ]),
                        (0, vue_2.createElementVNode)("button", {
                            class: (0, vue_2.normalizeClass)(["searchbar-btn btn", [isLoadingClass.value, searchBarClass.value]])
                        }, _hoisted_5, 2 /* CLASS */)
                    ])
                ], 32 /* NEED_HYDRATION */)
            ]));
        };
    }
});
